import styles from "./Card.module.scss"

const Card = ({ label, value }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles["text-orange"]}>{value}</div>
      <div className={styles["label"]}>{label}</div>
    </div>
  )
}

export default Card
